<template>

<b-modal ref="bModal" @hidden="onHidden" @ok="$emit('save', user)" @shown="onShown" :ok-disabled="invalidUser" title="Nuevo Usuario"
         size="lg" header-bg-variant="success" header-text-variant="light"
         ok-title="Guardar" ok-variant="success" cancel-title="Cancelar">
  <user-form ref="userForm" v-model="user"/>
</b-modal>

</template>

<script>

import UserForm from './UserForm'

export default {
  name: 'AddUserModal',
  components: {UserForm},
  data() {
    return {
      user: {},
      shown: false
    }
  },
  computed: {
    invalidUser() {
      if (!this.shown) {
        return
      }
      return this.$refs.userForm && this.$refs.userForm.invalid
    }
  },
  methods: {
    show() {
      this.$refs.bModal.show()
    },
    onShown() {
      this.shown = true
      this.$refs.userForm.resetValidation()
    },
    onHidden() {
      this.user = {}
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/user/AddUserModal.vue